import { render, staticRenderFns } from "./LenderChart.vue?vue&type=template&id=2f48159d&scoped=true&"
import script from "./LenderChart.vue?vue&type=script&lang=js&"
export * from "./LenderChart.vue?vue&type=script&lang=js&"
import style0 from "./LenderChart.vue?vue&type=style&index=0&id=2f48159d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f48159d",
  null
  
)

export default component.exports